/* eslint-disable camelcase */
import { sendEventRio2 } from '@chegg/commerce-utils';
import { PurchaseClient, CurrencyCode, CountryCode, ProductInfo } from '@chegg/rio-event-schema-web';
export var R2wcEvent = /*#__PURE__*/function (R2wcEvent) {
  R2wcEvent["PURCHASE_EVENT"] = "com.chegg.rio.poc.PurchaseClient";
  return R2wcEvent;
}({});
/**
 * Rio2.0 Purchase event
 */
export var sendRio2PurchaseEvent = function sendRio2PurchaseEvent(_ref) {
  var _products$, _products$2, _products$3, _products$4;
  var cartId = _ref.cartId,
    data = _ref.data;
  var order = data.order,
    purchase = data.purchase,
    products = data.products,
    transaction_id = data.transaction_id;
  var currency_code = order.currency_code,
    tax_paid = order.tax_paid,
    subtotal = order.subtotal,
    total = order.total;
  var _purchase$billing_add = purchase.billing_address,
    city = _purchase$billing_add.city,
    state_province_region = _purchase$billing_add.state_province_region,
    country_code = _purchase$billing_add.country_code,
    postal_code = _purchase$billing_add.postal_code;
  var coupon_code = purchase.coupon_code,
    coupon_discount_amount = purchase.coupon_discount_amount;
  var rioData = new PurchaseClient.PurchaseClient().setCartId(cartId).setTransactionId(transaction_id).setCurrencyCode(CurrencyCode.CurrencyCode[currency_code]).setTaxAmount(tax_paid).setSubtotalAmount(subtotal).setTotalAmount(total).setCouponCode(coupon_code).setCouponDiscountValue(coupon_discount_amount).setBillingCity(city).setBillingCountry(CountryCode.CountryCode[country_code]).setBillingPostalCode(postal_code).setBillingState(state_province_region).setProductsList([new ProductInfo.ProductInfo().setProductId((_products$ = products[0]) === null || _products$ === void 0 ? void 0 : _products$.product_id).setQuantity((_products$2 = products[0]) === null || _products$2 === void 0 ? void 0 : _products$2.quantity).setProductTypeClient((_products$3 = products[0]) === null || _products$3 === void 0 ? void 0 : _products$3.product_type).setDisplayPrice((_products$4 = products[0]) === null || _products$4 === void 0 ? void 0 : _products$4.display_price)]);
  sendEventRio2({
    eventType: R2wcEvent.PURCHASE_EVENT,
    eventData: rioData
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/utils/RioEvents.js
// module id = 1527
// module chunks = 11